import { persistCombineReducers } from 'redux-persist';
import localforage from 'localforage';

import routeReducer from './atom/route/reducer';
import authReducer from './atom/auth/reducer';

const rootReducer = persistCombineReducers(
    {
        blacklist: ['route', 'auth'],
        key: 'mis',
        version: 1,
        storage: localforage,
    },
    {
        route: routeReducer,
        auth: authReducer,
    },
);

export default rootReducer;
